import React, { useContext, useState } from 'react'
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { getImages } from '../../Common/const';
const sliderData = [
    {
        "year": 2009,
        "make": "Ferrari",
        "model": "430",
        "mileage": 5501,
        "price": "799800",
        "images": [
            "featured-vehicle1.png"
        ],
        'link': '/vehicle-details/used-2009-ferrari-430-scuderia-spider-16m-tampa-fl-id-ZFFKW66A390167462'
    },
    {
        "year": 2020,
        "make": "Lamborghini",
        "model": "Huracan Evo",
        "mileage": 8204,
        "price": "279995",
        "images": [
            "featured-vehicle2.png"
        ],
        'link': '/vehicle-details/used-2020-lamborghini-huracan-evo-tampa-fl-id-ZHWUF4ZF1LLA12704'
    },
    {
        "year": 2017,
        "make": "Bentley",
        "model": "Continental",
        "mileage": 8265,
        "price": "164995",
        "images": [
            "featured-vehicle3.png"
        ],
        'link': '/vehicle-details/used-2017-bentley-continental-gt-supersports-tampa-fl-id-SCBFB7ZA8HC064504'
    },
    {
        "year": 2021,
        "make": "Ferrari",
        "model": "812 GTS",
        "mileage": 493,
        "price": "529800",
        "images": [
            "featured-vehicle4.png"
        ],
        'link': '/vehicle-details/used-2021-ferrari-812-gts-tampa-fl-id-ZFF97CMAXM0261862'
    },
    {
        "year": 1989,
        "make": "Lamborghini",
        "model": "",
        "mileage": 11605,
        "price": "794995",
        "images": [
            "ZA9C005A0KLA12728.png"
        ],
        'link':'/vehicle-details/used-1989-lamborghini-countach-25th-anniversary-tampa-fl-id-ZA9C005A0KLA12728'
    },
];

const FeaturedVehicles = ({featuredVehicles, numberFormatter, priceFormatter}) => {

    const [activeSlide, setActiveSlide] = useState(0);
    const settings = {
        customPaging: function (i) {
            return (
                <div
                    className='custom-paging-btn'
                >
                    {i + 1}
                </div>
            );
        },
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        beforeChange: (current, next) => setActiveSlide(next),
    };

    const isMobile = window.innerWidth <= 768;
    const visibleCars = isMobile ? featuredVehicles.slice(0, 4) : featuredVehicles.slice(0, 6);
    return (
        <>
            <section className='featured-vehicles-wrap'>
                <div className='container'>
                    <h4 className='xxl-title text-uppercase text-center wow reveal fadeInDown'>Featured Vehicles</h4>
                    <div className='featured-vehicle-black'>
                        <Slider {...settings} className='featured-vehicle-slider'>
                            {visibleCars.map((car, index) => (
                                <div
                                    key={index}>
                                    <div
                                        className='d-md-flex align-items-center position-relative'
                                    >
                                        <div className={`fv-right order-md-2`}>
                                            <Link to={"/vehicle-details/" + car.vdp_url}><img className={activeSlide === index ? "animated fadeInRight " : ""} src={car.vdp_hero_image} alt='car' /></Link>
                                        </div>
                                        <div className={`fv-left ${activeSlide === index ? "animated fadeInLeft " : ""}`}>
                                            <div className={`fv-title1 mb-2`}>{car.year}</div>
                                            <div className={`fv-title2 mb-2`}>{car.make}</div>
                                            <div className={`fv-title3`}>{car.model || <>&nbsp;</>}</div>
                                            <div className={`mt-xl-5 mt-md-4 mt-2 fv-mi`}>{priceFormatter(car.mileage)} mi</div>
                                            <div className='d-md-block d-flex align-items-center justify-content-between mt-md-0 mt-2'>
                                                <div className={`fv-title2 avenir-next mt-md-2`}>{priceFormatter(car.price, true)}</div>
                                                <div className={`mt-md-2 mt-0`}>
                                                    <Link to={"/vehicle-details/" + car.vdp_url} className='fv-view-dtl text-uppercase'>View Details</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-md-end text-center mt-4 d-none d-md-block'>
                                        <Link to="/cars-for-sale-florida-california/all" className='black-red-btn text-uppercase d-inline-block'>View All Inventory</Link>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className='text-center mt-4 d-block d-md-none'>
                        <Link to="/cars-for-sale-florida-california/all" className='black-red-btn text-uppercase d-inline-block w-270 fw-700'>View All Inventory</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturedVehicles